var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container flex-wrap flex-line align-stretch relative"},[_c('div',{staticStyle:{"width":"220px"}},[_c('VerticleMenu',{attrs:{"menus":_vm.menus,"actived-key":_vm.activedMenuKey}})],1),_c('div',{staticClass:"relative",staticStyle:{"flex-grow":"1"}},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }